import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';
import { APIConstant } from 'src/app/shared/constant/api.constant';
import { NavigationConstant } from 'src/app/shared/constant/navigation.constant';
import { MessageConstant } from 'src/app/shared/constant/message.constant';
import { RequestHelper } from 'src/app/shared/helper/request.helper';
import { Router } from '@angular/router';
import { BriSyariahStorage } from 'src/app/shared/storage/bri-syariah.storage';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';

@Component({
  selector: 'app-inquiry-bri-syariah',
  templateUrl: '../../inquiry.component.html',
  styleUrls: ['./inquiry-bri-syariah.component.css']
})
export class InquiryBriSyariahComponent implements OnInit {


  hostname: any = environment.hostName;
  form: FormGroup;
  isLoading = false;
  isSubmitted = false;

  maxLength: number = 17;
  imagePath = 'https://cdn-doku.oss-ap-southeast-5.aliyuncs.com/doku-ui-framework/doku/img/bank/brisyariah.png';
  moduleName = 'BRI Syariah VA';

  constructor(
    private apiService: RequestHelper,
    private router: Router,
    private storage: BriSyariahStorage
  ) {
    this.form = new FormBuilder().group({
      vaNumber: [null, [Validators.required, Validators.maxLength(this.maxLength)]]
    });
  }

  ngOnInit() {
  }

  submitInquiry() {
    this.isSubmitted = true;
    if (!this.form.valid) {
      return;
    }
    this.isLoading = true;
    this.apiService.post(environment.apiUrl + APIConstant.BRISYARIAH_INQUIRY,
      JSON.stringify(this.form.getRawValue())).subscribe((data) => {

        if (data == null) {
          this.openDialog(MessageConstant.CANNOT_PROCESS);
        } else {
          this.getDataResponse(data);
        }

      }, (err) =>
        this.openDialog(MessageConstant.CANNOT_PROCESS));
    // this.router.navigate([NavigationConstant.BRISYARIAH_PAYMENT]); for mock, activate
  }

  getDataResponse(data: any) {
    if (data.status == '500') {
      if (data.message.includes('bills already paid')) {
        this.openDialog(MessageConstant.ALREADY_PAID);
      } else if (data.message.includes('date was expired')) {
        this.openDialog(MessageConstant.EXPIRED);
      } else {
        this.openDialog(MessageConstant.NOT_FOUND);
      }
    } else {
      this.storage.data = data;
      data.vaNumber = this.form.get('vaNumber').value;
      return this.router.navigate([NavigationConstant.BRISYARIAH_PAYMENT]);
    }
  }

  openDialog(result) {
    this.apiService.openDialog(result, NavigationConstant.BRISYARIAH_INQUIRY);
  }

}